import React from 'react';

export default function Tooltip({ children, text, show, className = '' }) {
  return (
    <div className={`relative flex items-center group ${className}`}>
      {children}
      {show && (
        <div className="absolute left-full ml-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 pointer-events-none">
          {text}
          {/* Arrow */}
          <div className="absolute top-1/2 right-full -mt-1 border-4 border-transparent border-r-gray-900" />
        </div>
      )}
    </div>
  );
}
